import { createContext, useContext } from 'react';

import type { Robot, Routine } from '@sb/remote-control/types';
import usePageRobotAndRoutine from '@sbrc/hooks/usePageRobotAndRoutine';

interface PageRobotRoutineState {
  robot: Robot.ConvertedResponse | null | undefined;
  routine: Routine.ConvertedResponse | null | undefined;
}

const PageRobotRoutineContext = createContext<PageRobotRoutineState | null>(
  null,
);

export function PageRobotRoutineProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageRobotAndRoutine();

  return (
    <PageRobotRoutineContext.Provider value={value}>
      {children}
    </PageRobotRoutineContext.Provider>
  );
}

/**
 * Read robot and routine data from the nearest PageRobotRoutineProvider.
 * This avoids creating duplicate Feathers subscriptions — all consumers
 * share a single subscription managed by the provider.
 */
export function usePageRobotRoutine(): PageRobotRoutineState {
  const ctx = useContext(PageRobotRoutineContext);

  if (!ctx) {
    throw new Error(
      'usePageRobotRoutine must be used within a PageRobotRoutineProvider',
    );
  }

  return ctx;
}
